import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toastr, Tooltip } from "@revvsales/components";

// Component Imports
import CloneTemplatePopup from "../../DocTemplates/CloneTemplatePopup";
import DropdownContainer from "../../AssetWrapper/DropdownContainer";
import TemplateNameEditPopup from "../../CreateTemplatePopup/TemplateNameEditPopup";
import { ReactSelect, Dropdown } from "../../../commonComponents";

// Action Imports
import { DocumentTemplateActions } from "../../../actions";

// Internal imports
import { GlobalUtils, AmplitudeUtils } from "../../../utils";
import { PATHS, TEMPLATE, EVENTS, PERMISSIONS } from "../../../constants";
import { USER_ROLES } from "../../../constants/roleList";
import TEMPLATE_ICO from "../../../assets/document-icons/template.png";

// Destructuring
const {
  formatDate,
  truncateString,
  checkUserPermission,
  readDataFromLocalStorage,
} = GlobalUtils;
const { changeTemplateStatus } = DocumentTemplateActions;
const {
  TEMPLATE_STATUS_OPTIONS,
  TEMPLATE_ROW_SETTINGS_OPTIONS,
  TEMPALTE_USER_GROUP_COLOR,
} = TEMPLATE;
const { amplitudeLogEvent } = AmplitudeUtils;
// const { initTeammatesSettingsData } = UserActions;

class TemplateTableRow extends Component {
  constructor(props) {
    super(props);
    this.settingDropdownRef = React.createRef();
    this.statusDropdownRef = React.createRef();
    this.state = {
      showStatusDropdown: false,
      showTagsDropdown: false,
      showSettingsDropdown: false,
      showCloneTemplatePopup: false,
      showTemplateItemRenamePopup: false,
      showUserGroupDropdown: false,
    };
  }

  // componentDidMount() {
  //   this.props.initTeammatesSettingsData();
  // }

  _toggleOptions = state => {
    if (!this.state.showStatusDropdown && state === "showStatusDropdown") {
      document.addEventListener("click", this._handleStatusClickOutside, false);
    }
    if (this.state.showStatusDropdown && state === "showStatusDropdown") {
      document.removeEventListener(
        "click",
        this._handleStatusClickOutside,
        false,
      );
    }
    this.setState(prevState => ({ [state]: !prevState[state] }));
  };

  _toggleSettingsDropdown = () => {
    if (!this.state.showSettingsDropdown) {
      document.addEventListener(
        "click",
        this._handleSettingDropdownOutsideClick,
        false,
      );
    } else {
      document.removeEventListener(
        "click",
        this._handleSettingDropdownOutsideClick,
        false,
      );
    }
    this.setState(
      prevState => ({
        showSettingsDropdown: !prevState.showSettingsDropdown,
      }),
      () => {
        // set template id for deletion
        if (this.state.showSettingsDropdown) {
          this.props.setSeletedTemplateId(this.props.id);
        }
      },
    );
  };

  _handleSettingDropdownOutsideClick = e => {
    const node = this.settingDropdownRef.current;
    // ignore clicks on the component itself
    if (node && node.contains(e.target)) {
      return;
    }
    this._toggleSettingsDropdown();
  };

  _handleStatusClickOutside = e => {
    const node = this.statusDropdownRef.current;
    if (node && node.contains(e.target)) {
      return;
    }
    this._toggleOptions("showStatusDropdown");
  };

  _dropdownOptionsData = () => {
    const options = TEMPLATE_ROW_SETTINGS_OPTIONS.map(option => {
      switch (option.id) {
        case "rename": {
          return {
            ...option,
            action: () => {
              this._toggleOptions("showTemplateItemRenamePopup");
            },
          };
        }
        case "delete": {
          return {
            ...option,
            action: () => {
              this.props.toggleDeleteConfirmationPopup();
            },
          };
        }
        case "clone": {
          return {
            ...option,
            action: () => {
              this._toggleOptions("showCloneTemplatePopup");
            },
          };
        }
        default:
          return { ...option };
      }
    });

    return {
      icon: "caret-circle-down",
      iconType: "fas",
      position: "bottom",
      title: "",
      selectedClassNameIdent: "",
      className: "templatetablerow-settings-dropdown",
      options,
    };
  };

  handleTagsDropdownCloseOutside = () => {
    const { showTagsDropdown } = this.state;
    if (showTagsDropdown) {
      this.setState({ showTagsDropdown: !showTagsDropdown });
    }
  };

  handleUserGroupDropdownCloseOutside = () => {
    this.setState({ showUserGroupDropdown: false });
  };

  _getTemplateStatusSwitchButton = () => {
    const { templateStatus, id: templateId } = this.props;
    const statusColor =
      templateStatus.toLowerCase() === "active" ? "#09AB36" : "#A7AAAC";
    const style = {
      control: base => ({
        ...base,
        border: 0,
        // This line disable the blue border
        boxShadow: "none",
        cursor: "pointer",
        backgroundColor: `${
          templateStatus.toLowerCase() === "active"
            ? "rgba(120, 186, 234, 0.2)"
            : "rgba(167, 170, 172, 0.2)"
        }`,
        minHeight: "29px",
        borderRadius: "26px",
      }),
    };

    const value = TEMPLATE_STATUS_OPTIONS[0].options.map(
      data => data.buttontext,
    );
    let switchBtn;
    if (value.length > 0) {
      switchBtn = (
        <span
          onClick={() => this._toggleOptions("showStatusDropdown")}
          ref={this.statusDropdownRef}
          onKeyPress={() => {}}
          data-id={`status${templateId}`}
          role="button"
          tabIndex="0"
          className="tabledetails-status">
          <span
            style={{
              // stylelint-disable-next-line
              backgroundColor: statusColor,
              marginRight: "-21px",
              marginLeft: "11px",
              marginTop: "1px",
            }}
            className="status-color-container"
          />
          <ReactSelect
            onChange={e => this._changeTemplateStatus(e)}
            isSearchable={false}
            options={value}
            value={
              templateStatus.toLowerCase() === "active" ? "Active" : "Inactive"
            }
            data-test="tabledetails-status"
            styles={style}
            className={`${
              templateStatus.toLowerCase() === "active"
                ? "tabledetails-status-active"
                : "tabledetails-status-inactive"
            } ${
              this.state.showStatusDropdown
                ? "tabledetails-status-focus"
                : "tabledetails-status-nonfocus"
            }`}
          />
          {!this.state.showStatusDropdown ? (
            <FontAwesomeIcon
              icon={["fas", "angle-down"]}
              className="templatestatus-angledown"
              color="#445673"
            />
          ) : (
            <FontAwesomeIcon
              icon={["far", "angle-up"]}
              className="templatestatus-angleup"
              color="#445673"
            />
          )}
        </span>
      );
    }

    if (templateStatus === "DRAFT") {
      switchBtn = (
        <span id="switch-state" className="tabledetails-status draft">
          <span
            style={{
              // stylelint-disable-next-line
              backgroundColor: "#78BAEA",
            }}
            className="status-color-container"
          />{" "}
          Draft
        </span>
      );
    }
    if (this.state.showSwitchBtnLoader) {
      return <FontAwesomeIcon icon={["far", "spinner"]} className="fa-spin" />;
    }
    return switchBtn;
  };

  _changeTemplateStatus = e => {
    const payload = {
      status: e.value === "Active" ? "Active" : "Deactive",
      template_type: "",
    };
    const status = e.value === "Active" ? "Activated" : "Deactivated";
    const { label } = this.props;
    this.setState({ showSwitchBtnLoader: true });
    const amplitudeObject = {
      oldStatus: this.props.templateStatus,
      newStatus: payload.status,
      tag: this.props.templateTag && this.props.templateTag.name,
      templateID: this.props.id,
      templateName: this.props.label,
    };
    this.props
      .changeTemplateStatus(this.props.id, payload, true)
      .then(() => {
        amplitudeLogEvent(
          EVENTS.EVENT_NAMES.TEMPLATE_STATUS_CHANGED,
          amplitudeObject,
        );
        this.setState({ showSwitchBtnLoader: false });
        Toastr.showToastr({
          type: "success",
          message: `Your template ${label} has been ${status}.`,
          timeout: 3000,
        });
      })
      .catch(error => {
        this.setState({ showSwitchBtnLoader: false });
        console.error(`TemplateTableRow => _changeTemplateStatus => ${error}`);
        Toastr.showToastr({
          type: "failure",
          message: "Something went wrong. Please try again!",
          timeout: 3000,
        });
      });
  };

  _toggleUserGroup = () => {
    this.setState({ showUserGroupDropdown: true });
  };

  render() {
    const {
      id: templateId,
      label,
      profileUrl,
      lastModified,
      templateTag,
      templateOwner,
      templateUsergroups,
    } = this.props;
    const { showTagsDropdown, showUserGroupDropdown } = this.state;

    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");

    return (
      <Fragment>
        {/* <div className="templatesdetails-table-row templatedetails-table-wrap"> */}
        {CURRENT_USER.roles[0].name === USER_ROLES.ADMIN ? (
          <Fragment>
            <div className="templatesdetails-table-row templatedetails-table-wrap">
              <div className="templatedetails-table-item td-col-label">
                <img
                  src={TEMPLATE_ICO}
                  className="templatedetails-icon file"
                  alt="template-ico"
                />
                <Link to={`${PATHS.DOCSTEMPLATE_PATH}/${templateId}`}>
                  <span className="templatedetails-label">
                    <span className="templatedetails-label-text">
                      <span>
                        {label ? truncateString(label, 32, true) : null}
                      </span>
                    </span>
                  </span>
                </Link>
              </div>
              <div
                onClick={() => this._toggleUserGroup("showUserGroupDropdown")}
                onKeyPress={() => {}}
                role="button"
                tabIndex="0"
                className="templatedetails-table-item td-col-tag contains-dropdown">
                {templateUsergroups && templateUsergroups.length > 0 ? (
                  templateUsergroups.map((item, index) => {
                    const firstLetter = item.name.charAt(0);
                    const color = TEMPALTE_USER_GROUP_COLOR[index];

                    return (
                      <Tooltip
                        placement="bottom"
                        align={{
                          offset: [0, -1],
                        }}
                        overlay={item.name}>
                        <div
                          className="tabledetails-usergroup"
                          style={{ background: color }}>
                          <span>{firstLetter}</span>
                        </div>
                      </Tooltip>
                    );
                  })
                ) : (
                  <div className="user-group-icon">
                    <span className="user-group-empty-icon">
                      <FontAwesomeIcon
                        icon={["fas", "users"]}
                        className="templatedetails-icon file"
                      />
                    </span>
                    <span className="user-group-add-icon">
                      <FontAwesomeIcon
                        icon={["fas", "plus"]}
                        className="templatedetails-icon file"
                      />
                    </span>
                  </div>
                )}
                {showUserGroupDropdown && (
                  <DropdownContainer
                    templateId={templateId}
                    id={`groups${templateId}`}
                    type="userGroups"
                    className="tag-dropdown"
                    showMenu={showUserGroupDropdown}
                    templateUsergroups={templateUsergroups}
                    closeDropdownContainer={
                      this.handleUserGroupDropdownCloseOutside
                    }
                  />
                )}
              </div>
              <div className="templatedetails-table-item td-col-tag contains-dropdown">
                <div
                  onClick={() => this._toggleOptions("showTagsDropdown")}
                  onKeyPress={() => {}}
                  data-id={`tags${templateId}`}
                  role="button"
                  tabIndex="0"
                  className={`${
                    templateTag ? "tabledetails-tag" : "tabledetails-notag"
                  } ${
                    showTagsDropdown
                      ? "template-showtags-dd"
                      : "template-hidetags-dd"
                  }`}>
                  {templateTag && templateTag.name.length <= 10 && (
                    <div>
                      <FontAwesomeIcon icon={["far", "tag"]} color="#70682c" />{" "}
                      {truncateString(templateTag.name, 10, true)}
                    </div>
                  )}
                  {templateTag && templateTag.name.length > 10 && (
                    <Tooltip
                      placement="top"
                      align={{
                        offset: [0, 4],
                      }}
                      overlayClassName="templatetags-tooltip"
                      mouseLeaveDelay={0.1}
                      overlay={templateTag.name}>
                      <div>
                        <FontAwesomeIcon
                          icon={["far", "tag"]}
                          color="#70682c"
                        />{" "}
                        {truncateString(templateTag.name, 8, true)}
                      </div>
                    </Tooltip>
                  )}
                  {!templateTag && (
                    <span>
                      {" "}
                      <FontAwesomeIcon
                        icon={["far", "plus-circle"]}
                        color="#70682c"
                        className="show-empty-regular"
                      />
                      <FontAwesomeIcon
                        icon={["fas", "plus-circle"]}
                        color="#70682c"
                        className="show-empty-solid"
                      />
                    </span>
                  )}
                  <span
                    className={`dd-arrow ${
                      showTagsDropdown ? "show-dd-open" : ""
                    }`}>
                    <FontAwesomeIcon
                      icon={["far", "angle-down"]}
                      className="asset-angle-down"
                    />
                  </span>
                </div>
                {showTagsDropdown && (
                  <DropdownContainer
                    templateId={templateId}
                    id={`tags${templateId}`}
                    type="tags"
                    className="tag-dropdown"
                    showMenu={showTagsDropdown}
                    templateTag={templateTag}
                    closeDropdownContainer={this.handleTagsDropdownCloseOutside}
                  />
                )}
              </div>
              <div className="templatedetails-table-item td-col-status contains-dropdown-status">
                {this._getTemplateStatusSwitchButton()}
              </div>
              <div className="templatedetails-table-item td-col-modifiedby">
                <Tooltip
                  placement="topLeft"
                  overlay={templateOwner}
                  mouseLeaveDelay={0}
                  align={{
                    offset: [4, 0],
                  }}>
                  <span className="tabledetails-userprofile-img ">
                    <img alt="Revv" src={profileUrl} />
                  </span>
                </Tooltip>
                <span className="tabledetails-modified-date">
                  {/* {moment(updatedDateTime).fromNow()}{" "} */}
                  {formatDate(lastModified, "lll")}
                </span>
              </div>
              <div className="templatetablerow-settings">
                {checkUserPermission(
                  PERMISSIONS.TEMPLATES.DELETE_TEMPLATES,
                ) && (
                  <Dropdown
                    options={this._dropdownOptionsData()}
                    showDropdown={this.state.showSettingsDropdown}
                    showDropdownHandler={this._toggleSettingsDropdown}
                    dropdownRef={this.settingDropdownRef}
                    // toolTip={{ placement: "top", overlay: "More options" }}
                  />
                )}
              </div>

              {/** CLONE TEMPLATE POPUP SECTION */}
              <section>
                {this.state.showCloneTemplatePopup && (
                  <CloneTemplatePopup
                    closePopup={() =>
                      this._toggleOptions("showCloneTemplatePopup")
                    }
                    id={templateId}
                    docName={label}
                  />
                )}
              </section>

              {/* RENAME TEMPLATE POPUP SECTION */}
              <section>
                {this.state.showTemplateItemRenamePopup && (
                  <TemplateNameEditPopup
                    purpose="RENAME ONLY"
                    show={this.state.showTemplateItemRenamePopup}
                    onClose={() =>
                      this._toggleOptions("showTemplateItemRenamePopup")
                    }
                    docName={label}
                    templateId={templateId}
                    templateStatus={this.props.templateStatus}
                  />
                )}
              </section>
            </div>
          </Fragment>
        ) : (
          CURRENT_USER.roles[0].name === USER_ROLES.USER &&
          this.props.templateStatus === "ACTIVE" && (
            <Fragment>
              <div className="templatesdetails-table-row templatedetails-table-wrap">
                <div className="templatedetails-table-item td-col-label">
                  <img
                    src={TEMPLATE_ICO}
                    className="templatedetails-icon file"
                    alt="template-ico"
                  />
                  <Link to={`${PATHS.DOCSTEMPLATE_PATH}/${templateId}`}>
                    <span className="templatedetails-label">
                      <span className="templatedetails-label-text">
                        <span>
                          {label ? truncateString(label, 32, true) : null}
                        </span>
                      </span>
                    </span>
                  </Link>
                </div>
                <div className="templatedetails-table-item td-col-tag contains-dropdown">
                  <div className={templateTag ? "tabledetails-tag" : ""}>
                    {templateTag ? (
                      <div>
                        <FontAwesomeIcon
                          icon={["far", "tag"]}
                          color="#70682c"
                        />{" "}
                        {truncateString(templateTag.name, 20, true)}
                      </div>
                    ) : (
                      <span>No tag</span>
                    )}
                  </div>
                </div>
                <div className="templatedetails-table-item td-col-status contains-dropdown-status">
                  <span id="switch-state" className="tabledetails-status draft">
                    Active
                  </span>
                </div>
                <div className="templatedetails-table-item td-col-modifiedby">
                  <Tooltip
                    placement="topLeft"
                    overlay={templateOwner}
                    mouseLeaveDelay={0}
                    align={{
                      offset: [4, 0],
                    }}>
                    <span className="tabledetails-userprofile-img ">
                      <img alt="Revv" src={profileUrl} />
                    </span>
                  </Tooltip>
                  <span className="tabledetails-modified-date">
                    {/* {moment(updatedDateTime).fromNow()}{" "} */}
                    {formatDate(lastModified, "lll")}
                  </span>
                </div>
                <div className="templatetablerow-settings">
                  {checkUserPermission(
                    PERMISSIONS.TEMPLATES.DELETE_TEMPLATES,
                  ) && (
                    <Dropdown
                      options={this._dropdownOptionsData()}
                      showDropdown={this.state.showSettingsDropdown}
                      showDropdownHandler={this._toggleSettingsDropdown}
                      dropdownRef={this.settingDropdownRef}
                      // toolTip={{ placement: "top", overlay: "More options" }}
                    />
                  )}
                </div>
                {/** CLONE TEMPLATE POPUP SECTION */}
                <section>
                  {this.state.showCloneTemplatePopup && (
                    <CloneTemplatePopup
                      closePopup={() =>
                        this._toggleOptions("showCloneTemplatePopup")
                      }
                      id={templateId}
                      docName={label}
                    />
                  )}
                </section>

                {/* RENAME TEMPLATE POPUP SECTION */}
                <section>
                  {this.state.showTemplateItemRenamePopup && (
                    <TemplateNameEditPopup
                      purpose="RENAME ONLY"
                      show={this.state.showTemplateItemRenamePopup}
                      onClose={() =>
                        this._toggleOptions("showTemplateItemRenamePopup")
                      }
                      docName={label}
                      templateId={templateId}
                      templateStatus={this.props.templateStatus}
                    />
                  )}
                </section>
              </div>
            </Fragment>
          )
        )}
        {/* </div> */}
      </Fragment>
    );
  }
}

const mapDispatchToProps = {
  changeTemplateStatus: (id, data) => changeTemplateStatus(id, data, true),
  // initTeammatesSettingsData,
};
export default connect(
  null,
  mapDispatchToProps,
)(TemplateTableRow);



// WEBPACK FOOTER //
// ./src/components/TemplateV2/OrgTemplates/TemplateTableRow.js